



import Vue, { PropType } from "vue";
import VueApexCharts from "vue-apexcharts";

type DoughnutChartData = {
  labels: string[];
  revenue: number[];
};

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    series: [] as number[],
    options: {},
  }),
  created() {
    this.updateData();
  },
  props: {
    chartData: { type: Object as PropType<DoughnutChartData> },
    colorList: { type: Array as PropType<string[]> },
  },
  methods: {
    getHeight() {
      if (this.$vuetify.breakpoint.xl || this.$vuetify.breakpoint.lg) {
        return "250";
      }
      return "auto";
    },
    updateData() {
      this.series = this.chartData.revenue;
      this.options = {
        chart: {
          type: "donut",
          animations: {
            enabled: false,
          },
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          pie: {
            customScale: 0.8,
            expandOnClick: false,
            donut: {
              size: "80%",
              background: "transparent",
              labels: {
                show: false,
              },
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 250,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        legend: {
          show: false,
        },
        states: {
          active: {
            filter: {
              type: "none",
            },
          },
        },
        colors: this.colorList,
        tooltip: {
          fillSeriesColor: false,
          x: {
            show: false,
          },
        },
        labels: this.chartData.labels,
      };
    },
  },
  watch: {
    colorList: function () {
      this.updateData();
    },
  },
});
